<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_77" data-name="Group 77" transform="translate(-594.988 -280.287)">
    <circle id="Ellipse_1" data-name="Ellipse 1" cx="35.201" cy="35.201" r="35.201" transform="translate(594.988 280.287)" fill="#fff"/>
    <g id="Group_1" data-name="Group 1" transform="translate(-1133.858)">
      <path id="Path_1" data-name="Path 1" d="M1773.949,297.522a46.951,46.951,0,0,1-9.9-4.471,46.917,46.917,0,0,1-9.9,4.471,55.057,55.057,0,0,1-9.382,1.625V317.2c0,17.223,19.282,23.077,19.282,23.077s19.282-5.854,19.282-23.077V299.147A55.038,55.038,0,0,1,1773.949,297.522Z" fill="#1a1818"/>
      <path id="Path_2" data-name="Path 2" d="M1766.143,314.036a4.336,4.336,0,0,0,.5-.294c.065-.042.124-.09.187-.135.106-.08.207-.164.305-.252a4.786,4.786,0,1,0-6.8-.623c.05.063.1.125.152.185.1.112.2.22.31.321a4.849,4.849,0,0,0,.443.366c.063.045.123.094.188.136a4.546,4.546,0,0,0,.505.3c-3.472.9-6.029,4.206-6.029,10.854h16.267C1772.172,318.242,1769.615,314.934,1766.143,314.036Z" fill="#fff"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_02_02_e',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SC_02_02_e.vue